import dynamic from 'next/dynamic';
import { useMemo } from 'react';

import ResourceConversionPanel from 'organisms/Cards/ResourceConversionPanel';

import type { ListingConfigProps } from 'layout/Listing/config';
import type { FC } from 'react';

const BlogListing = dynamic(() => import('layout/Listing/variants/blog'), {
  ssr: true,
});

const ConnectorsListing = dynamic(() => import('layout/Listing/variants/connectors'), {
  ssr: true,
});

const CustomerStoryListing = dynamic(() => import('layout/Listing/variants/customerStories'), {
  ssr: true,
});

const EventsListing = dynamic(() => import('layout/Listing/variants/events'), {
  ssr: true,
});

const GuideListing = dynamic(() => import('layout/Listing/variants/guides'), {
  ssr: true,
});

const PressListing = dynamic(() => import('layout/Listing/variants/press'), {
  ssr: true,
});

const ResourceCenter = dynamic(() => import('layout/Listing/variants/resourceCenter'), {
  ssr: true,
});

const ToolsListing = dynamic(() => import('layout/Listing/variants/tools'), {
  ssr: true,
});

const VideosListing = dynamic(() => import('layout/Listing/variants/videos'), {
  ssr: true,
});

const Listing: FC<ListingConfigProps> = ({ type, ...props }) => {
  const ListingComponent = useMemo(() => {
    switch (type) {
      case 'blog':
        return BlogListing;
      case 'connectors':
        return ConnectorsListing;
      case 'customerStories':
        return CustomerStoryListing;
      case 'events':
        return EventsListing;
      case 'press':
        return PressListing;
      case 'guides':
        return GuideListing;
      case 'resources':
        return ResourceCenter;
      case 'tools':
        return ToolsListing;
      case 'videos':
        return VideosListing;
      default:
        return null;
    }
  }, [type]);

  if (!ListingComponent) {
    return (
      <div className="flex w-full flex-col gap-2">
        <ResourceConversionPanel
          variation="basic"
          heading="Invalid Listing Type"
          description="Please select a valid Listing Type in the block settings."
          theme="dark"
        />
      </div>
    );
  }

  return <ListingComponent {...props} />;
};

export default Listing;
